import { Injectable } from '@angular/core';
import { Resolve } from '@angular/router';
import { Observable } from 'rxjs';
import { AuthService } from './auth.service';

@Injectable({
    providedIn: 'root',
})
export class AuthResolver implements Resolve<boolean> {
    constructor(
        private readonly authService: AuthService
    ) {}

    resolve(): Observable<boolean> {
        return new Observable<boolean>((observer) => {
            this.authService.isInitialized$.subscribe((isInitialized) => {
                if (isInitialized) {
                    observer.next(true);
                    observer.complete();
                } else {
                    observer.next(false);
                    observer.complete();
                }
            });
        });
    }
}
